import {getAccessToken} from "../tools/helper";
import http from "./HttpServices";


export const BASE_URL = 'https://api.shadzi.club';
// export const BASE_URL = 'http://127.0.0.1:8000';


export const basePostData = async (endPoint, data, multiPart = false) => {
    http.axios.defaults.headers.common["Authorization"] = await getAccessToken();
    return http.post(endPoint, data, {headers: {"Content-Type": multiPart ? 'multipart/form-data' : 'application/json'}});
}

export const baseGetData = async (endPoint) => {
    http.axios.defaults.headers.common["Authorization"] = await getAccessToken()
    return http.get(endPoint);
}
